import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'
import {
    Body,
    ButtonAction,
    ButtonsContainer,
    ContentContainer,
    dialogPanel,
    dialogTitle
} from './styles'
import { IoCloseSharp } from 'react-icons/io5'
import ambulatorio from '../../../assets/svg/ambulatorioCopa.svg'
import { NotificationReducer } from 'types/notification'
import { useSelector } from 'react-redux'
import { RootReducerState } from 'types/global'

interface ForwardNotificationModalProps {
    handleOpenForwardNotification: () => void
    handleCloseModal: () => void
    isOpen: boolean
    errorMessage: string
}

const ForwardNotificationModal: React.FC<ForwardNotificationModalProps> = ({
    handleCloseModal,
    isOpen,
    handleOpenForwardNotification,
    errorMessage
}) => {
    const notificationSelector: NotificationReducer = useSelector(
        (state: RootReducerState) => state.notificationsReducer
    )
    const send = () => {
        handleOpenForwardNotification()
    }
    return (
        <>
            <Transition
                appear
                show={isOpen}
                as={Fragment}
                data-testid="test-ForwardNotificationModal"
            >
                <Dialog
                    as="div"
                    className="relative z-10"
                    onClose={handleCloseModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className={dialogPanel}>
                                    <Dialog.Title
                                        as="h3"
                                        className={dialogTitle}
                                    >
                                        <p className="text-blueTheme text-xl font-semibold">
                                            Encaminhar Notificação
                                        </p>
                                        <IoCloseSharp
                                            onClick={handleCloseModal}
                                            className="text-blueTheme h-8 w-8 p-1 cursor-pointer"
                                        />
                                    </Dialog.Title>

                                    <Body>
                                        <p className="text-xs">
                                            Ao encaminhar, o setor responsável
                                            receberá a notificação para iniciar
                                            o tratamento.
                                        </p>
                                        <ContentContainer>
                                            <p className="text-sm text-center font-semibold">
                                                A notificação será enviada para
                                            </p>
                                            <div className="flex items-center justify-center mt-2">
                                                <img
                                                    src={ambulatorio}
                                                    alt="logos"
                                                    width={24}
                                                />
                                                <span className="ml-3 text-amberAlt">
                                                    {
                                                        notificationSelector
                                                            ?.notificationById
                                                            ?.incident_sector
                                                            ?.display_value
                                                    }
                                                </span>
                                            </div>
                                        </ContentContainer>
                                        <ButtonsContainer>
                                            <ButtonAction
                                                onClick={() => {
                                                    handleCloseModal()
                                                }}
                                                type="button"
                                                className="text-blueTheme text-sm"
                                            >
                                                Cancelar
                                            </ButtonAction>

                                            <ButtonAction
                                                onClick={() => {
                                                    send()
                                                }}
                                                className="bg-blueTheme text-white text-sm"
                                            >
                                                Encaminhar para tratamento
                                            </ButtonAction>
                                        </ButtonsContainer>
                                        {errorMessage && (
                                            <span className="text-errorText flex justify-center mt-2 text-sm">
                                                {errorMessage}
                                            </span>
                                        )}
                                    </Body>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}

export { ForwardNotificationModal }
